export function InformationIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.5 7C1.5 3.96243 3.96243 1.5 7 1.5C10.0376 1.5 12.5 3.96243 12.5 7C12.5 10.0376 10.0376 12.5 7 12.5C3.96243 12.5 1.5 10.0376 1.5 7ZM7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5ZM7.5 10.3333L7.5 6.33333L6.5 6.33333L6.5 10.3333H7.5ZM7.5 5L7.5 3.66667H6.5L6.5 5H7.5Z'
        fill='currentColor'
      />
    </svg>
  )
}
